import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ILocationWSState {
  gpsWS?: WebSocket;
  gpsWsReadyState: number;
}

let initialState: ILocationWSState = {
  gpsWsReadyState: WebSocket.CLOSED,
};

const slice = createSlice({
  name: "location-ws",
  initialState,
  reducers: {
    initGPSWs: () => {},
    closeGPSWs: (state) => {
      state.gpsWsReadyState = WebSocket.CLOSED;
      state.gpsWS = undefined;
    },
    setGPSWsReadyState: (state, { payload }: PayloadAction<number>) => {
      state.gpsWsReadyState = payload;
    },
    setGPSWs: (state, { payload }: PayloadAction<WebSocket>) => {
      state.gpsWS = payload;
    },
  },
});

export const { initGPSWs, closeGPSWs, setGPSWsReadyState, setGPSWs } =
  slice.actions;

export const LOCATION_WS = slice.name;
export default slice.reducer;
